import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/verification/admin/diditInboxQueryKeys.ts
var t = e("admin-didit-inbox", {
	list: (e, t) => e === void 0 && t === void 0 ? ["list"] : [
		"list",
		e,
		t
	],
	stats: () => ["stats"]
});
//#endregion
export { t as diditInboxQueryKeys };
